import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class HisenseDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default HisenseDeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/hisense/DeviceSetup.js